import DetailsCard, { SelectOptions } from "@/components/DetailsCard/DetailsCard";
import { useState } from "react";
import { Person } from "../types";
import EditPersonModal from "./EditPersonModal";

interface PersonCardProps {
  name: string;
  pgaId: string;
  pdrCredits?: React.ReactNode;
  options?: SelectOptions[];
  onSave: (value: Person) => void;
  className?: string;
  title: string;
  userCanEdit: boolean;
}

export default function PersonCard({
  name,
  pgaId,
  pdrCredits,
  options = [],
  onSave,
  className,
  title,
  userCanEdit
}: PersonCardProps) {
  const [isEditing, setIsEditing] = useState(false);
  const onEdit = userCanEdit ? () => setIsEditing(true) : undefined;

  return (
    <>
      <DetailsCard
        className={className}
        heading={title}
        options={[
          {
            overline: "Name",
            headline: name,
            supportingText: (
              <div className="flex flex-col gap-1">
                <div>PGA ID: {pgaId}</div>
                <div>{pdrCredits}</div>
              </div>
            ),

            iconName: "person"
          },
          ...options
        ]}
        onEdit={onEdit}
      />

      <EditPersonModal
        open={isEditing}
        onClose={() => setIsEditing(false)}
        title={title}
        initialName={name}
        onSave={onSave}
      />
    </>
  );
}
